<template>
  <div class="blocked-page">
    <div class="container">
      <div class="icon">🚫</div>

      <h1 class="title">{{ $t('blocked.title') }}</h1>

      <p class="message">
        {{ $t('blocked.message') }}
      </p>

      <div class="reason" v-show="false">
        <span class="reason-label">{{ $t('blocked.reasonLabel') }}</span>
        <span class="reason-text">{{ reason }}</span>
      </div>

      <div class="contact-info" v-show="false">
        <div class="contact-title">{{ $t('blocked.contactTitle') }}</div>
        <div class="contact-item">📧 {{ $t('blocked.contactEmail') }}</div>
        <div class="contact-item">📱 {{ $t('blocked.contactPhone') }}</div>
        <div class="contact-item">💬 {{ $t('blocked.contactHours') }}</div>
      </div>

      <button @click="goHome" class="button" v-show="false">{{ $t('blocked.backToHome') }}</button>

      <div class="details">
        <div class="details-item">{{ $t('blocked.time') }}: {{ blockTime }}</div>
        <div class="details-item">{{ $t('blocked.ip') }}: {{ userIP }}</div>
        <div class="details-item">{{ $t('blocked.id') }}: {{ blockId }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlockedPage',
  data() {
    return {
      reason: this.$t('blocked.defaultReason'),
      userIP: '-',
      blockId: '-',
      blockTime: '-'
    }
  },
  mounted() {
    this.loadBlocklistInfo()
  },
  methods: {
    loadBlocklistInfo() {
      // Try to get blocklist info from route query
      const { reason, ip, id } = this.$route.query

      if (reason || ip || id) {
        this.reason = reason || this.$t('blocked.defaultReason')
        this.userIP = ip || '-'
        this.blockId = id || '-'
      } else {
        // Try to get from localStorage
        const storedInfo = localStorage.getItem('blacklist_info')
        if (storedInfo) {
          try {
            const info = JSON.parse(storedInfo)
            this.reason = info.reason || this.$t('blocked.defaultReason')
            this.userIP = info.ip || '-'
            this.blockId = info.id || '-'

            // Clear stored info
            localStorage.removeItem('blacklist_info')
          } catch (e) {
            console.error('Failed to parse blacklist info:', e)
          }
        }
      }

      // Set current time
      this.blockTime = new Date().toLocaleString()
    },

    goHome() {
      this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.blocked-page {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  margin: 0;
}

.container {
  background: white;
  border-radius: 10px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  padding: 60px 40px;
  text-align: center;
  max-width: 500px;
  width: 100%;
}

.icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 30px;
  background: #ff6b6b;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  color: white;
}

.title {
  color: #2c3e50;
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 20px;
}

.message {
  color: #7f8c8d;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 30px;
}

.reason {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 15px;
  margin-bottom: 30px;
  color: #495057;
  font-size: 14px;
}

.reason-label {
  font-weight: 600;
  color: #6c757d;
  display: block;
  margin-bottom: 5px;
}

.contact-info {
  background: #e3f2fd;
  border-radius: 6px;
  padding: 20px;
  margin-bottom: 30px;
}

.contact-title {
  color: #1976d2;
  font-weight: 600;
  margin-bottom: 10px;
}

.contact-item {
  color: #424242;
  margin-bottom: 5px;
  font-size: 14px;
}

.button {
  background: #667eea;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s;
  text-decoration: none;
  display: inline-block;
}

.button:hover {
  background: #5a6fd8;
}

.details {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e9ecef;
  font-size: 12px;
  color: #adb5bd;
}

.details-item {
  margin-bottom: 5px;
}

@media (max-width: 480px) {
  .container {
    padding: 40px 20px;
  }

  .title {
    font-size: 24px;
  }
}
</style>